<template>
  <div>
    <b-row class="mt-4">
      <!-- <b-col md="4" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Search"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col> -->
      <!-- <b-col md="2" class="my-1" align="right">
        <b-form-group label-cols-sm="6" label="Show" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group>
      </b-col> -->
      <b-col md="3" class="my-1"></b-col>
      <!-- <b-col md="3" class="my-1" align="right">
        <b-button variant="primary" @click="showModalFormUniversalVoucher('create', '')">
          <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
        </b-button>
      </b-col> -->
    </b-row>
    <br />
    <!-- <section v-if="table_error">
      <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
    </section> -->
    <b-row>
      <b-col md="6">
        <b-table
          responsive
          show-empty
          hover
          ref="universalVoucherTable"
          :items="getDataUniversalVoucher"
          :fields="types"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          head-variant="light"
          class="bg-white"
        >
          <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
          <template v-slot:cell(voucher_name)="{ item }">
            <p class="mb-0">{{item.voucher_name}}</p>
          </template>
          <template v-slot:cell(action)="{item}">
            <b-row style="justify-content:center">
              <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteUniversalVoucher(item.voucher_name, item.voucher_name)">
                <img src="@/assets/rectangle.svg" class="mr-2" alt />
              </b-link>
            </b-row>
          </template>
        </b-table>
        <div>
          <b-row>
            <b-col class="pr-0">
              <input type="text" class="form-control" v-validate="'required'"
                name="voucher_name"
                v-model="voucher_name"
                data-vv-as="Voucher Name" placeholder="Type Voucher">
                <b-form-invalid-feedback id="input-voucher_name-feedback">{{
                  veeErrors.first("voucher_name")
                }}</b-form-invalid-feedback>
            </b-col>
            <b-col class="text-center justify-content-center pl-0"> 
            <b-button variant="primary" @click="createUniversalVoucher()" :disabled="loading_form_universal_voucher" block>
              Add
            </b-button>
          </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row class="mx-auto">
      <b-col md="4" align="left" class="mx-auto px-0">
        <div v-if="totalRows == 0 || totalRows == null">
          Showing 0 Records
        </div>
        <div v-else>
          Showing {{ fromPage[currentPage - 1] }} to
          {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
        </div>
      </b-col>
      <b-col md="4" class="mx-auto"></b-col>
      <b-col md="4" align="right" class="px-0">
        <b-pagination
          align="right"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      table_error: false,
      loading_universal_voucher: false,
      loading_form_universal_voucher: false,
      modalFormVoucherUniversalShow: false,
      universal_voucher: {
        id: "",
        voucher_name: "",
        membership: [],
      },
      voucher_name: "",
      universal_vouchers: [],
      types: [
        {
          key: "voucher_name",
          label: "Voucher Name",
          sortable: false,
          class: "text-left w-10"
        },
        { key: "action", label: "Action", class: "text-center w-10" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: "",
      // universal_voucher_name: "",
      // universal_voucher_membership_selected: [],
      universal_voucher_membership: [
        {text: "Gold", value: "gold"},
        {text: "Silver", value: "silver"},
        {text: "Gold2.0", value: "gold2.0"},
        {text: "Silver2.0", value: "silver2.0"},
        {text: "Non Member", value: "non_member"},
      ]
    }
  },
  methods: {
    getDataUniversalVoucher(ctx, callback) {
      this.loading_universal_voucher = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("app_name", "PaxelMarket3");
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("VoucherModule/getUniversalVouchersWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.universal_vouchers = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_universal_voucher = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get universal voucher",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_universal_voucher = false;
          callback([]);
        });
      return null;
    },
    showModalFormUniversalVoucher(action, id) {
      this.universal_voucher = {
        id: "",
        voucher_name: "",
        membership: [],
      };
      if (action == 'edit') {
        this.$store
        .dispatch("VoucherModule/getUniversalVoucher", id)
        .then(response => {
          this.universal_voucher = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
      }
      this.modalFormVoucherUniversalShow = !this.modalFormVoucherUniversalShow;
    },
    createUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_universal_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.voucher_name);
          formData.append("app_name", "PaxelMarket3");
          this.$store
            .dispatch("VoucherModule/postUniversalVoucher", formData)
            .then((response) => {
              this.loading_form_universal_voucher = false;
              this.voucher_name = ""
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.$validator.reset();
              this.modalFormVoucherUniversalShow = false;
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store universal voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_universal_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    editUniversalVoucher() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading_form_universal_voucher = true;
          const formData = new FormData();
          formData.append("voucher_name", this.universal_voucher.voucher_name);
          formData.append("membership", this.universal_voucher.membership);
          this.$store
            .dispatch("VoucherModule/putUniversalVoucher", {
              id: this.universal_voucher.id,
              formData
            })
            .then((response) => {
              this.loading_form_universal_voucher = false;
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.modalFormVoucherUniversalShow = false;
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.data : "Failed store universal voucher",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
              this.loading_form_universal_voucher = false;
            });
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    deleteUniversalVoucher(id, voucherName) {
      var payload = {
        app_name:"PaxelMarket3",
        voucher_id:id
      }
      this.$swal({
        text: `Are you sure want to delete ${voucherName}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("VoucherModule/deleteUniversalVoucher", payload)
            .then((response) => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              console.log(response);
              this.$refs.universalVoucherTable.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>